import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { organizationsSearchOptions } from "@/queryOptions/organizations";
import { updateQueryClientOrganizations } from "@/utils/queryClientUpdate";

export const useOrganizationQuery = (
  query: string,
  stateIds?: string[],
  countyIds?: string[],
  cityIds?: string[],
  channelTypeIds?: string[],
) => {
  const queryClient = useQueryClient();
  const queryResult = useQuery(
    organizationsSearchOptions(
      query,
      stateIds,
      countyIds,
      cityIds,
      channelTypeIds,
    ),
  );

  useEffect(() => {
    if (queryResult.data) {
      updateQueryClientOrganizations(queryClient, queryResult.data);
    }
  }, [queryResult.data, queryClient]);

  return queryResult;
};
